module.exports = __webpack_public_path__ + "img/mon-4.3cde6948.png";